import { Logger } from '@feature-hub/core';
import { BffLoggerCall } from '@volkswagen-onehub/vw-starter-types-support';
import fetch from '@strictsoftware/fetch';
import type { BffQueryParams, NdpsDomainResponse } from '../types/bff';

export interface BffFetchOptions extends BffQueryParams {
	readonly baseUrl?: string;
	readonly logger: Logger;

	readonly [key: string]: string | string[] | boolean | undefined | unknown;
}

export class BffFetchError extends Error {
	public constructor(
		message: string,
		public readonly bffLoggerCalls?: BffLoggerCall[],
	) {
		super(message);
	}
}

class ConfigProviderManager {
	private static instance: ConfigProviderManager;
	private googleApiKey: string | null = null;
	private dataUrl: string | null = null;
	private brand: string | null = null;
	private bffUrl: string | null = null;
	private bffCdnUrl: string | null = null;
	private bffHeaders: Object | null = null;

	private constructor() {}

	static getInstance(): ConfigProviderManager {
		if (!ConfigProviderManager.instance) {
			ConfigProviderManager.instance = new ConfigProviderManager();
		}
		return ConfigProviderManager.instance;
	}

	setConfigs(configs?: any): void {
		this.brand = configs['es-vwdata']?.customConfig?.brand || null;

		this.dataUrl = configs['es-vwdata']?.urlOrigin + configs['es-vwdata']?.urlPath + '/' + this.brand;

		this.bffUrl = configs['es-oneform-bff']?.urlOrigin + configs['es-oneform-bff']?.urlPath;
		this.bffCdnUrl = configs['es-oneform-bff-cdn']?.urlOrigin + configs['es-oneform-bff-cdn']?.urlPath;
		this.bffHeaders = configs['es-oneform-bff-cdn']?.customConfig || null;

		this.googleApiKey = configs['es-google-apikey']?.customConfig?.apiKey || null;
	}

	getDataUrl(): string | null {
		return this.dataUrl;
	}

	getBrand(): string | null {
		return this.brand;
	}

	getBffUrl(): string | null {
		return this.bffUrl;
	}

	getBffCdnUrl(): string | null {
		return this.bffCdnUrl;
	}

	getBffHeaders(): Object | null {
		return this.bffHeaders;
	}

	getGoogleApiKey(): string | null {
		return this.googleApiKey;
	}
}

export const configProviderManager = ConfigProviderManager.getInstance();

export const fetchBff = async (path: string, formData?: FormData): Promise<NdpsDomainResponse | null> => {
	try {
		const headers = configProviderManager.getBffHeaders();
		const url = formData ? configProviderManager.getBffUrl() : configProviderManager.getBffCdnUrl();

		const response = await fetch(`${url}/${path}`, {
			method: formData ? 'POST' : 'GET',
			headers: headers ? (headers as Record<string, string>) : {},
			body: formData,
		});

		return await response.json();
	} catch (err) {
		//reportErrorSentry(err);
		return null;
	}
};
